export enum ScenePathEnum {
  precisionCutting = 'precision-cutting',
  ligatingLoop = 'ligating-loop',
  pegTransfer = 'peg-transfer',
  intracorporealKnot = 'intracorporeal-knot',
  extracorporealKnot = 'extracorporeal-knot',
  stratafix = 'stratafix',
}
